import { Variant } from '@shared/types/product';
import { Product as CsvProduct } from '@/components/organisms/quick-order/types';
import { isRemovedFromSaleForLocale } from '@/utils/product/lifecycle';

export const mapCsvProduct = (variant: Variant, locale?: string): CsvProduct => {
  // NOTE: `quantity` here is the AVAILABLE quantity from the catalogue, not a
  // requested quantity — the uploaded row's requested quantity lives on the
  // parsed row and is compared against this.
  return {
    sku: variant.sku,
    quantity: variant.availableQuantity ?? 0,
    inStock: variant.isOnStock,
    exists: true,
    // EWM-944 — carried so Quick Order can tell a back-orderable OOS line from
    // one that is excluded from back order altogether. Region-scoped: GO is
    // per-country and both storefronts ship from one deployment, so a
    // cross-company derivation would reject an NZ-only GO SKU on AU.
    removedFromSale: isRemovedFromSaleForLocale((variant.attributes ?? {}) as Record<string, unknown>, locale),
  } as CsvProduct;
};
